import * as moment from 'moment';
export default (function (_ref, inject) {
  var store = _ref.store;
  // eslint-disable-next-line import/namespace
  moment.locale(store.$i18n.locale);
  inject("moment", moment);
});